import { render, staticRenderFns } from "./category-result.vue?vue&type=template&id=67224564&"
import script from "./category-result.vue?vue&type=script&lang=js&"
export * from "./category-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports